import { render, staticRenderFns } from "./total-sessions.vue?vue&type=template&id=6ec7a3c6&scoped=true&"
import script from "./total-sessions.vue?vue&type=script&lang=js&"
export * from "./total-sessions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec7a3c6",
  null
  
)

export default component.exports